import { v4 as uuid } from 'uuid';

const formatBackendMessages = (messages: Array<{ message: { id: string; timestamp: string } }> = []) =>
  messages.map((root) => {
    const { id: messageId, ...message } = root.message;

    return {
      ...root,
      frontendId: messageId ?? uuid(),
      message: { ...message, _id: messageId },
    };
  });

export default formatBackendMessages;
